import React, {useEffect} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { classNames, dateTimeToString, dateToString, numPad } from '../../../Services/helpers';

const DateTime = ({label, name, help, onChange, min, max, step, time, prefix, suffix, disabled, validators, showDatePrompts, datePrompts, defaultNow}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    useEffect(() => {
        if (defaultNow && !value) {
            handleChange(time === false ? dateToString(new Date()) : dateTimeToString(new Date(), 'T') );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, defaultNow]);

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div className="relative flex flex-row">
            <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{prefix}</span>
            </div>

            <input className="block w-full border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6 placeholder-fix"
                type={time === false ? 'date' : 'datetime-local'}
                value={value}
                min={min}
                max={max}
                step={step}
                onChange={e => handleChange(e.target.value)}
                disabled={isDisabled}
                placeholder={time === false ? 'dd/mm/yyyy' : 'dd/mm/yyyy HH:MM'}
            />

            <div className="pointer-events-none inset-y-0 right-0 flex items-center pl-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{suffix}</span>
            </div>
        </div>

        {showDatePrompts && <div className="mt-3">
            {datePrompts ?
                datePrompts.map((prompt, index) =>
                    dateButton(prompt.days, handleChange, value, time, isDisabled, prompt.label, index)
                )
                :
                [0, 1, 2, 3, 4].map(days =>
                    dateButton(days, handleChange, value, time, isDisabled, null, days)
                )
            }
        </div>}

    </CommonFieldWrapper>
}

const dateButton = (days, handleChange, value, time, isDisabled, customLabel = null, key = null) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    const str = date.getUTCFullYear() + '-' + numPad(date.getUTCMonth() + 1) + '-' + numPad(date.getUTCDate());

    let title;
    if (customLabel) {
        title = customLabel;
    } else if (days === 0) {
        title = 'Today';
        // } else if (days === 1) {
        //     title = 'Tomorrow';
    } else if (days <= 5) {
        title = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()];
    } else {
        title = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }

    return <button key={key || days} className={classNames(
            'btn-sm mr-2',
            value === str ? 'btn-light-selected' : 'btn-light',
            isDisabled && 'cursor-not-allowed text-gray-400 fill-gray-400',
        )}
        onClick={(e) => {
            e.preventDefault();
            if (time === false) {
                handleChange(str);
            } else {
                // In case there's time involved in the value, we want to keep that
                handleChange(value ? value.replace(/\d{4}-\d{2}-\d{2}/, str) : str+'T12:00')
            }
        }}
        disabled={isDisabled}
    >
        {title}
    </button>
}


export default DateTime;
